import { CongratulationsPage } from './CongratulationsPage';

export { CongratulationsPage };
